var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":"","absolute":"","min-height":"56px","max-height":"64px","color":"white","outlined":""}},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"alt":"VSM Service","contain":"","max-width":"130","src":require("@/assets/logo_color.png")}})],1),_c('v-spacer'),_c('BtnHelp'),_c('Settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }